import React from "react";
import { Lock } from "lucide-react";

/**
 * Inline lock card shown in place of a Pro-only computed section (kill
 * sheet results, step-down schedule, etc.) for Free users — the section's
 * inputs stay fully visible/editable elsewhere on the page, only the
 * derived engineering output is withheld. `onUnlock` should open the
 * shared SubscribeModal.
 */
export default function PremiumResultsLock({ label = "these results", onUnlock }) {
  return (
    <div
      data-testid="premium-results-lock"
      className="card-rs p-4 flex flex-wrap items-center justify-between gap-3"
      style={{ borderColor: "rgba(245,180,0,0.45)", background: "rgba(245,180,0,0.05)" }}
    >
      <div className="flex items-center gap-2">
        <Lock className="w-4 h-4 text-[var(--rs-amber)]" />
        <span className="text-[12px] text-[var(--rs-text-2)]">
          <strong className="text-[var(--rs-amber)]">RigSentinel Pro</strong> unlocks {label}.
        </span>
      </div>
      <button
        type="button"
        onClick={onUnlock}
        className="text-[12px] px-3 py-1.5 rounded font-medium"
        style={{ background: "var(--rs-amber)", color: "#0A0B0E", minHeight: 32 }}
      >
        Upgrade
      </button>
    </div>
  );
}
